
<template>
  <!--新增版本-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
let decoratorOptions = {
  app_id: {
    rules: [{required: true, message: '请选择应用'}]
  },
  version: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入版本号'},
      {min: 2, max: 20, message: '版本号为2-20个字'}
    ]
  },
  code: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入code'},
      {min: 2, max: 10, message: 'code为2-10个字'}
    ]
  },
  content: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入更新说明'},
      {min: 2, max: 100, message: '更新说明为2-100个字'}
    ]
  },
  is_force: {valuePropName: 'checked', rules: []}
};
export default {
  mixins: [mixin.fetchSelect],
  name: 'addVersion',
  data () {
    return {
      platform: '',
      formList: [
        {
          label: '应用',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用',
          handle: this.appChange,
          props: ['app_id', decoratorOptions.app_id]
        },
        {
          label: '平台',
          inputType: 'select',
          options: this.$store.state.platformList,
          placeholder: '请选择平台',
          handle: this.platformChange,
          props: ['os_type', {
            rules: [{required: true, message: '请选择平台'}]
          }]
        },
        {
          label: '更新说明',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入更新说明',
          props: ['content', decoratorOptions.content]
        },
        {
          label: 'APK',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'sdk_id',
          resUrl: 'apk_file',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            accept: this.$store.state.apkAccept
          },
          beforeHandle: this.beforeHandle,
          props: ['sdk_id', {
            rules: [{required: true, message: '请选择apk'}]
          }]
        },
        {
          label: '版本号',
          inputType: 'input',
          options: [],
          placeholder: '请输入版本号',
          blur: this.verifyVersion,
          props: ['version', decoratorOptions.version]
        },
        {
          label: '是否强制升级',
          inputType: 'checkbox',
          options: [],
          placeholder: '',
          props: ['is_force', decoratorOptions.is_force]
        }
      ],
      formKey: {
        app_id: '',
        version: '',
        code: '',
        os_type: '',
        content: '',
        sdk_id: '',
        is_force: ''
      },
      addParam: {
        url: '/app_version',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/app_version/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/app_version/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.marketingManageSelect([{index: 0, key: 'apps_list', scope: 'formList'}]);
  },
  methods: {
    /** 处理文件上传前事件
     * 当平台选择为小黑盒才自动设置版本号
     * 2020040802.bin => 20.04.08.02
     */
    beforeHandle (file, fileList) {
      if (this.platform === 3 && file.name) {
        let name = file.name;
        let year = name.slice(2,4);
        let month = name.slice(4, 6);
        let date = name.slice(6, 8);
        let version = name.slice(8, 10);
        let str = [year, month, date, version];
        let versionStr = str.join('.');
        this.$refs.addEdit.form.setFieldsValue({ version: versionStr });
      }
    },
    /* 应用类型 change */
    appChange (e) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'os_type') {
          let list = [...this.$store.state.platformList];
          // 当应用为门禁时，平台选项只要安卓和小黑盒选项
          e === 3 ? el.options = [list[0], { label: '小黑盒', value: 3 }] : el.options = list;
        }
      });
    },
    /* 平台类型 change */
    platformChange (e) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'sdk_id') {
          let rule = props[1].rules[0];
          e === 2 ? rule.required = false : rule.required = true;
          e === 3 ? el.label = '固件' : el.label = 'APK';
          this.platform = e;
        }

        if (props && props[0] === 'version') {
          e === 3 ? el.disabled = true : el.disabled = false;
        }
      });
    },
    /* 验证版本号是否重复 */
    verifyVersion () {
      this.$refs.addEdit.form.validateFields(['version', 'app_id', 'os_type'], (err, values) => {
        if (err) { return; }
        this.$post({
          url: '/app_version/check',
          params: values
        }).then((res) => {
          this.$message.success(`${res.msg}`);
        });
      });
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    detailResHandle (data) {
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }
      formValues.sdk_id = data.apk_file_id;
      data.is_force === 1 ? formValues.is_force = true : formValues.is_force = false;
      this.appChange(data.app_id);
      this.platformChange(data.os_type);
      return formValues;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/systemSet/appVersion/addVersion.vue